import { Component, Host, h, type JSX, Prop } from '@stencil/core'
import { type JSXBase } from '@stencil/core/internal'
import { type GaugeCircle } from '../../utils/utils'

@Component({
    tag: 'gauge-component',
    styleUrl: 'gauge-component.scss',
    shadow: true,
})

export class GaugeComponent {
    displayOptions = {
        half: {
            size: 180,
            rotation: 180,
        },
        semi: {
            size: 270,
            rotation: 135,
        },
        full: {
            size: 360,
            rotation: -90,
        },
    }

    @Prop() min: number = 0
    @Prop() max: number = 100
    @Prop() value: number = 90
    @Prop() backgroundstroke: number = 10
    @Prop() backgroundstrokecolor: string = 'pink'
    @Prop() percentagestroke: number = 10
    @Prop() percentagestrokecolor: string = 'deeppink'
    @Prop() mode: string = 'semi'
    @Prop() linecap: JSXBase.SVGAttributes<SVGElement>['stroke-linecap'] = 'round'
    @Prop() prefixtext: string = ''
    @Prop() suffixtext: string = ''
    @Prop() duration: number = 100
    @Prop() ease: string = 'ease-in-out'
    @Prop() animatenumbers: boolean = true
    @Prop() maglrWidth: number = 10

    getCircle = ({ radius, stroke, size, rotation, percent, part }: GaugeCircle): JSX.Element => {
        const innerRadius = radius - Math.max(this.backgroundstroke, this.percentagestroke) / 2
        const circumference = innerRadius * 2 * Math.PI
        const arc = circumference * (size / 360)
        const dashArray = `${arc} ${circumference}`
        const transform = `rotate(${rotation}, ${radius}, ${radius})`
        const offset = arc - (percent / 100) * arc

        return (
            <circle
                cx={radius}
                cy={radius}
                fill="transparent"
                r={innerRadius}
                stroke-dasharray={dashArray}
                stroke-dashoffset={part === 'percentage' ? offset : 0 }
                stroke-linecap={this.linecap}
                stroke-width={stroke}
                stroke={part === 'percentage' ? this.percentagestrokecolor : this.backgroundstrokecolor }
                style={{
                    transition: `stroke-dashoffset ${this.ease} ${this.duration}ms`,
                }}
                transform={transform}
                part={part}
            />
        )
    }

    gauge = (): JSX.Element => {
        const radius = this.maglrWidth / 2

        const percent = ((this.value - this.min) / (this.max - this.min)) * 100
        const { size, rotation } = this.displayOptions[this.mode]
        return (
            <svg height={this.maglrWidth} width={this.maglrWidth }>
                {this.getCircle({ stroke: this.backgroundstroke, part: 'base', radius, size, rotation, percent })}
                {this.getCircle({ stroke: this.percentagestroke, part: 'percentage', radius, size, rotation, percent })}
            </svg>
        )
    }

    render (): JSX.Element {
        return (
            <Host>
                {this.gauge()}
            </Host>
        )
    }
}
